import { Text } from '@enechain/ecloud-designsystem'

/** 値が無い列の表示。 値のある列と見分けられるよう低強調色の「—」を出す。 */
export const NoValue = (): React.ReactElement => (
  <Text as="span" color="Text.lowEmphasis">
    —
  </Text>
)

/** 文字列の列の表示。 未設定と空文字は [[NoValue]]。 */
export const TextOrNoValue = ({
  value,
}: {
  value: string | undefined
}): React.ReactElement =>
  value !== undefined && value !== '' ? <span>{value}</span> : <NoValue />

/**
 * 数値 (decimal 文字列) の列の表示。 未設定は [[NoValue]]、 値は `digits` 桁に整える。
 * 入札一覧と入札履歴で価格 (2 桁)・数量 (1 桁) の桁を揃えるための共通部品。
 */
export const NumberOrNoValue = ({
  value,
  digits,
}: {
  value: string | undefined
  digits: number
}): React.ReactElement =>
  value !== undefined ? <>{Number(value).toFixed(digits)}</> : <NoValue />
